<template>
  <div class="cst-upload">
    <van-uploader
      :max-count="maxCount"
      :file-list="fileList"
      :after-read="onAfterRead"
      @delete="deleteFile"
    />
  </div>
</template>
<script>
import { upload } from "@/api";
export default {
  name: "Upload",
  components: {},
  props: {
    value: {
      type: [String, Array],
      default: "",
    },
    maxCount: {
      type: [Number, String],
      default: 9,
    },
  },
  data() {
    return {
      fileList: [],
      isArrayValue: false,
      isUpdatingFromValue: false,
    };
  },
  computed: {},
  watch: {
    value: {
      immediate: true,
      handler(v) {
        this.isArrayValue = Array.isArray(v);
        this.isUpdatingFromValue = true;
        if (v) {
          if (this.isArrayValue) this.fileList = v.map((url) => ({ url }));
          else
            this.fileList = String(v)
              .split(",")
              .filter((i) => i !== "")
              .map((url) => ({ url }));
        } else this.fileList = [];
        this.$nextTick(() => {
          this.isUpdatingFromValue = false;
        });
      },
    },
    fileList: {
      deep: true,
      handler(v) {
        if (this.isUpdatingFromValue) return;
        const urls = v.filter((d) => d.url).map((d) => d.url);
        if (this.isArrayValue) this.$emit("input", urls);
        else this.$emit("input", urls.join(","));
      },
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    // onBeforeRead(...args) {
    //   console.log(JSON.stringify(args))
    //   return true
    // },
    deleteFile(_, data) {
      const { index } = data || {};
      this.fileList.splice(index, 1);
      // console.log(args)
    },
    onAfterRead(vfile) {
      const { file } = vfile || {};
      const data = new FormData();
      data.append("file", file);
      upload(data)
        .then((res) => {
          console.log(res);
          const { code, data, message } = res || {};
          if (code == 0) {
            const { url } = data || {};
            if (url) {
              this.fileList.push({ url: url });
            }
          } else this.fileList.push({ status: "failed", message });
        })
        .catch((err) =>
          this.fileList.push({ status: "failed", message: "上传失败!" })
        );
    },
  },
};
</script>
<style>
.cst-upload {
  padding: 8px 0 0 8px;
}
</style>
